import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/app/global-error.tsx");
